<script lang="ts">
  import { getKehrblattControlAuthContext } from "../../../_shared/_logic/auth-context"
  import LearningWorkspace from "./_modules/learning-workspace"
  const { organizationId, organizationSlug = null } = $props<{
    organizationId: string
    organizationSlug?: string | null
    organizationResolvedId?: string | null
  }>()
  const auth = getKehrblattControlAuthContext()
  const organization = $derived(organizationSlug || organizationId)
</script>

{#if $auth?.currentUserId}
  {#key `${organization}:${$auth.currentUserId}`}
    <LearningWorkspace {organization} userId={$auth.currentUserId} />
  {/key}
{:else}
  <p role="status">KehrBlatt lernen wird geladen …</p>
{/if}
